import { useState } from 'react';
import { updatePreferences } from '../../utilities/api/users';
import { fullAccessPreferencesMenu, analystAccessPreferencesMenu, preferenceOptions } from '../../utilities/services/preferencesOptions';
import './Preferences.css';




export default function Preferences({ user, updateUser, docketPreferences, setDocketPreferences, updateDocketPreferences, handleDropdownClick }) {
    const [ isChangingPreferences, setIsChangingPreferences ] = useState(false)
    const handleCheckboxChange = async (evt) => {
        setIsChangingPreferences(true)
        const { id, value } = evt.target
        const option = id.split('-')[0]
        const tempDocketPreferences = {...docketPreferences}
        if (!docketPreferences[`${option}Exclude`].includes(value)) {
            tempDocketPreferences[`${option}Exclude`].push(value)
        } else {
            tempDocketPreferences[`${option}Exclude`] = tempDocketPreferences[`${option}Exclude`].filter((item) => item !== value)
        }
        try {
            const res = await updatePreferences(user._id, { docketPreferences: tempDocketPreferences })
            window.localStorage.setItem('token', res.token)
            updateUser(res.updatedUser)
            setDocketPreferences(res.updatedUser.docketPreferences)
            setIsChangingPreferences(false)
        } catch (error) {
            console.log(error)
            setIsChangingPreferences(false)
        }
    }

  return (
    <div className='Preferences dropdown preferencesDropDown navItem'>
        <div className='preferencesDropDownToggle' id='preferencesDropDownToggle' title='Preferences' data-title='Preferences' data-bs-toggle="dropdown" data-bs-auto-close='outside' aria-expanded="false">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" fill="currentColor" className="bi bi-sliders" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1z"/>
            </svg>
        </div>
        <ul className='dropdown-menu preferencesDropDown' aria-labelledby="preferencesDropDownToggle" onClick={handleDropdownClick}>
            { Object.keys(['admin', 'manager'].includes(user.userType)? fullAccessPreferencesMenu : analystAccessPreferencesMenu).map((option, index) => (
            <li key={index} className='dropdown-item dropstart'>
                <div className='dropdownContent' data-bs-toggle="dropdown" data-bs-target={`#${option}Submenu`} aria-expanded="false">
                    <div>{['admin', 'manager'].includes(user.userType)? fullAccessPreferencesMenu[option] : analystAccessPreferencesMenu[option]}</div><div> &raquo;</div>
                </div>
                <ul className='submenu dropdown-menu' id={`${option}Submenu`}>
                    { Object.keys(preferenceOptions[option]).map((subOption, index) => (
                    <li key={index} className='dropdown-item'>
                        { docketPreferences[`${option}Exclude`] &&
                        <div className='form-check'>
                            <input className='form-check-input' 
                            id={`${option}-${subOption}`} 
                            type="checkbox" 
                            defaultChecked={
                                docketPreferences[`${option}Exclude`].includes(subOption) ? 
                                false
                                :
                                true
                            } 
                            value={subOption}
                            disabled={isChangingPreferences}
                            onClick={handleCheckboxChange} />
                            <label className='form-check-label' htmlFor={`${option}-${subOption}`}>
                                {preferenceOptions[option][subOption]}
                            </label>
                        </div>
                        }
                    </li>
                    ))}
                </ul>
            </li>
            ))}
        </ul>
    </div>
  );
}